import React, { useContext } from 'react';
import { PageLoadingContext } from '../features/loader/contexts/PageLoadingContext';
import getApolloClient from './configureApollo';
import { ApolloProvider } from '@apollo/client';

/**
 * @typedef {object} ApolloProviderInternalProps
 * @property {React.ReactNode} children
 */

/**
 * @param {ApolloProviderInternalProps} props
 */
const ApolloProviderInternal = props => {
  const { children } = props;

  const context = useContext(PageLoadingContext);

  const client = getApolloClient({
    incrementLoaderCounter: context.incrementLoaderCounter,
    decrementLoaderCounter: context.decrementLoaderCounter
  });

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};

export default ApolloProviderInternal;
